define.alias("shared/components/shared/youtube-tos-modal", "calendar/components/shared/youtube-tos-modal");